/** @format */

import { api } from 'utility';
import {
  getCreditUrl,
  getSayyahInquiry,
  postSayyahOtpResend,
  postSayyahOtpVerify,
  getFeature
} from 'URLs';

export function getCredit() {
  return api.get(getCreditUrl()).then((res) => res.data);
}

export function getFeatureList() {
  return api.get(getFeature()).then((res) => res.data);
}

export function getSayyahInquiryUrl() {
  return api.get(getSayyahInquiry()).then((res) => res.data);
}

export function requestSayyahOtp() {
  return api.post(postSayyahOtpResend()).then((res) => res.data);
}

export function verifySayyahOtp(otp) {
  return api
    .post(postSayyahOtpVerify(), null, { params: { otp } })
    .then((res) => res.data);
}

export default {
  getCredit,
  getSayyahInquiryUrl,
  requestSayyahOtp,
  verifySayyahOtp,
  getFeatureList
};